
/*
 *
 * Date: 2025
 * Description: Landing private page ( dashboar )
 * Author: Philippe Leroux @SKITSC
 *
 */


//Modules
import { ReactElement, useContext } from "react";
import { Box, Paper, Typography } from "@mui/material";
import { Link } from "react-router-dom";

//Context
import { MainContext } from "../context/context";


const Landing = ( ) : ReactElement => {

    const { user } = useContext(MainContext)
    return (
        <Box sx={{ height : '100%'}}>
            <Box sx={{ display : 'flex' , flexDirection : 'column' }}>
                <Paper sx={{ padding : 3 , border : '1px solid gray' , maxWidth : '550px' , width : '100%' , marginTop : '15vh' , marginLeft : 'auto' , marginRight : 'auto' , opacity : 0.9}}>
                    <Typography sx={{ textAlign : 'center' , fontSize : 22 , fontWeight : 'bolder'}}>Welcome back {user.username}</Typography>
                    <Box sx={{ textAlign : 'center' , marginTop : '1vh'}}>Take a look at our catalog <Box component={Link} to={'/catalog'} sx={{ cursor : 'pointer'}}>Click here!</Box></Box>
                </Paper>
            </Box>
        </Box>
    )
} 

export default Landing;